import './App.css';
import Router from "./config/Router"



function App() {
  return (
    <div className="App" style={{ backgroundColor: '#fafafa' }}>
      <Router />
    </div>
  );
}

export default App;
